import {TrustBlock} from 'components/common/TrustBlock/TrustBlock'
import {Ventrata} from 'types'
import {OrderInfo} from '../../OrderInfo'
import {Feedback} from './Feedback'

type Props = {
  order: Ventrata.Order
}

export const Right = ({order}: Props) => {
  return (
    <div className="flex flex-col gap-6 w-full d:w-[568px]">
      <OrderInfo order={order} />
      <TrustBlock />
      <Feedback />
    </div>
  )
}
